import { render } from "./NewVation.vue?vue&type=template&id=79123a5d&scoped=true&ts=true"
import script from "./NewVation.vue?vue&type=script&lang=ts"
export * from "./NewVation.vue?vue&type=script&lang=ts"

import "./NewVation.vue?vue&type=style&index=0&id=79123a5d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79123a5d"]])

export default __exports__